import React from "react";

import BtnModal from "../atoms/BtnModal";
import Modal from "../atoms/Modal";
const JsonModal = ({ showModal, closeModal, btnClick, id, data, json ,copyJson}) => {
  return (
    <>
      {showModal ? (
        <>
          <Modal title={"فایل نمونه JSON  این مدل"} closeModal={closeModal}>
            <div
              className="bg-gray-chart-200 w-336 h-350 px-3.5 py-5.5 overflow-y-scroll"
              dir="ltr">
              <pre className="block whitespace-pre-wrap ">
                {JSON.stringify(json, null, 2)}
                </pre>
            </div>
            {/*footer*/}
            <div className="flex items-center justify-end pt-5.5">
              <BtnModal text={"کپی کردن متن"} accept={copyJson} />
            </div>
          </Modal>
        </>
      ) : null}
    </>
  );
};

export default JsonModal;
